import React from 'react';
import { Marker, Popup, MapContainer, TileLayer, useMap } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

import { useEffect, useState } from 'react';

const ProductMap = (props: any) => {

  const [latitude, setLat] = useState<any>(props.latitude);

  const [longitude, setLong] = useState<any>(props.longitude);

  let DefaultIcon = L.icon({
      iconUrl: icon,
      shadowUrl: iconShadow
  });

  useEffect(()=>{

    setLat(props.latitude)
    setLong(props.longitude)

    console.log('latitude: '+props.latitude+' / longitude: '+props.longitude)

  }, [ props ])

  function ChangeView() {
    const map = useMap();
    map.setView([latitude,longitude], 12);
    return null;
  }

  L.Marker.prototype.options.icon = DefaultIcon;

  function ProductMap(props: any) {
    if (latitude !== 0 && longitude !== 0) {
      return (
        <MapContainer className="h-350px custom-radius" center={[latitude, longitude]} zoom={20} scrollWheelZoom={false}>
        <ChangeView />
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={[latitude, longitude]}>
          <Popup>
            A pretty CSS3 popup. <br /> Easily customizable.
          </Popup>
        </Marker>
        </MapContainer>
      );
    }

    return (
      <div></div>
    );
  }

return (
  <div>
    <ProductMap />
  </div>
)

}

export default ProductMap;
